
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M47 21V2H17v19H2v41h26V50h-3v-2h14v2h-3v12h26V21H47zM13 51H7v-6h6v6zm0-10H7v-6h6v6zm0-10H7v-6h6v6zm12 12h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm14-4h4v4h-4v-4zm0 8h4v4h-4v-4zm-5 12h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm4-12h-4v4h-4v-4h-4v-4h4V7h4v4h4v4zm1 28v-4h4v4h-4zm5 15h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2v-2h2v2zm13 1h-6v-6h6v6zm0-10h-6v-6h6v6zm0-10h-6v-6h6v6z"}})])
          )
        }
      }
    